import React from 'react'

const Loading = () => {
  return (
    <div className="section section-cneter">
      <div className="loading"></div>
    </div>
  )
}

export default Loading
